<template>
	<div class="center">
		<div class="nubPer">
			<div class="nubPer_tit">
				<span>新建级别卷号</span>
			</div>
			<div class="periods_form">
				<div class="periods_inf">
					<div class="fom_inf">
						<div class="fl_left tit">
							<span>名称</span>
						</div>
						<div class="fl_left per_tet">
							<input type="text" placeholder="请填写名称，例：第一级上卷" class="per_txt" v-model="perTxt">
							<div class="tishi">
								<span class="per_err"><i class="el-icon-warning"></i> 只可输汉字</span>
								<span class="per_suc"><i class="el-icon-success"></i></span>
								<span class="per_warn"><i class="el-icon-info">不可超过5个汉字</i></span>
							</div>
						</div>
					</div>
				</div>
				<div class="periods_inf">
					<div class="fom_inf">
						<div class="fl_left tit">
							<span>总课节数</span>
						</div>
						<div class="fl_left per_tet">
							<input type="text" placeholder="请填写该期课节数，例：20" class="lesson" v-model="lessons"  @input="lessons = lessons.replace(/[^\d]/g,'')">
							<!-- <div class="tishi">
								<span class="per_err"><i class="el-icon-warning"></i> 只可输正整数</span>
								<span class="per_suc"><i class="el-icon-success"></i></span>
								<span class="per_warn"><i class="el-icon-info">不可超过40节课</i></span>
							</div> -->
						</div>
					</div>
				</div>
				<div class="periods_inf">
					<div class="fom_inf">
						<div class="fl_left tit">
							<span>价格</span>
						</div>
						<div class="fl_left per_tet">
							<input type="text" placeholder="请填写价格" class="price" v-model="prices">
							<div class="tishi">
								<span class="per_err"><i class="el-icon-warning"></i> 只可输正整数</span>
								<span class="per_suc"><i class="el-icon-success"></i></span>
								<span class="per_warn"><i class="el-icon-info">不可超过10W</i></span>
							</div>
						</div>
					</div>
				</div>
				<div class="periods_inf">
					<div class="fom_inf">
						<div class="fl_left tit">
							<span>简介</span>
						</div>
						<div class="fl_left area_txt">
							<textarea name="" id="" class="introduction" placeholder="简介" v-model="introduction"></textarea>
							<span class="num_size">{{size_num}}</span>
							<div class="tishi">
								<span class="per_err"><i class="el-icon-warning"></i>不可超过120个字</span>
								<span class="per_suc"><i class="el-icon-success"></i></span>
							</div>
						</div>
					</div>
				</div>
				<div class="vue-uploader periods_inf">
					<div class="fom_inf">
						<div class="fl_left tit">
							<span></span>
						</div>
						<div class="fl_left">
							 <div class="file-list">
					            <section class="file-item draggable-item" v-if="src">
					                <img :src="src" alt="" ondragstart="return false;">
					            </section>
					            <section v-if="status == 'ready'" class="file-item">
					                <div @click="add" class="add"></div>
					            </section>
					        </div>
						</div>
					</div>
			    </div>
			</div>
			<div class="vue-oss-uploader-wrap" v-if="UPload">
				<div class="vue-oss-uploader">
					<div class="vue-oss-uploader-top clearfixed">
						<div class="vue-oss-top-title">选择文件</div>
						<div class="vue-oss-top-button" @click="addUpload">本地上传</div>
						<input type="file" @change="fileChanged" ref="file" multiple="multiple" accept="image/jpg,image/jpeg,image/png,image/bmp">
						<div class="vue-oss-top-close" @click="uploadButtonClose()">×</div>
					</div>
					<div class="vue-oss-uploader-content">
						<div class="vue-oss-uploader-information clearfixed">
							<div class="vue-oss-imgsrc fl_left" v-for="(item,index) in imgUrl" @click="selectImg(index)">
								<img :src="item" alt="">
								<div class="mark">
									<i class="fa fa-check"></i>
								</div>
							</div>
						</div>
						<div class="vue-oss-button" @click="qd_oss">
							<span>确定</span>
						</div>
					</div>
				</div>
			</div>
			<div class="btn_edit">
				<div>
					<button class="btn" @click="fn()">确定</button>
					<button class="btn btn1" @click="qx_xj()">取消</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				//size_num:120,
				perTxt:'',
				lessons:'',
				prices:'',
				introduction:'',
				src:'',
				status: 'ready',
                files: [],
                UPload:false,
                imgUrl:[],
				courseId:'',
				timer:null,
				dancelist:[]
			}
		},
		computed:{
			size_num(){
				let _this = this;
				var size_num = 120;
				if(_this.introduction.length > 120){
					_this.introduction=_this.introduction.substring(0,120);
				}
				var num=120 - _this.introduction.length
				return num;
			},
		},
		/*props:['formDat'],*/
		methods:{
			// size_reduce(){
			// 	var con=document.querySelector('.introduction');
			// 	var num=document.querySelector('.num_size');
			// 	this.timer=setInterval(function(){
			// 		if(con.value.length>120){
			// 			con.value=con.value.substring(0,120);
			// 		}else{
			// 			num.innerHTML=120-con.value.length;
			// 		}
			// 	},10)			},
			// stopaddNum(){
			// 	clearInterval(this.timer);
			// },
			fn(){
				var _this=this;
				if(this.perTxt==''||this.lessons==''||this.introduction==''||this.prices==''||this.src==''){
					this.$message({
		    			message:'请将信息填写完整',
		    			showClose:true,
		    			type:'waring'
		    		})
				}else{
					const txtreg=/^[\u4e00-\u9fa5]+$/;
					if(!txtreg.test(_this.perTxt)){
						$('.per_txt').addClass('per_error').siblings().find('.per_err').show().siblings().hide().parent().siblings().removeClass('per_warning per_success')
						return false;
					}else{
						if(_this.perTxt.length>5){
							$('.per_txt').addClass('per_warning').siblings().find('.per_warn').show().siblings().hide().parent().siblings().removeClass('per_error per_success')
							return false;
						}else{
							$('.per_txt').addClass('per_success').siblings().find('.per_suc').show().siblings().hide().parent().siblings().removeClass('per_error per_warning')
							const tablereg=/^([1-9]\d*|[0]{1,1})$/;
							if(!tablereg.test(_this.lessons)){
								$('.lesson').addClass('per_error').siblings().find('.per_err').show().siblings().hide().parent().siblings().removeClass('per_warning per_success')
								return false;
							}else{
								if(_this.lessons>40){
									$('.lesson').addClass('per_warning').siblings().find('.per_warn').show().siblings().hide().parent().siblings().removeClass('per_error per_success')
									return false;
								}else{
									$('.lesson').addClass('per_success').siblings().find('.per_suc').show().siblings().hide().parent().siblings().removeClass('per_error per_warning')
									const pricereg=/^\+?[1-9][0-9]*$/;
									if(!pricereg.test(_this.prices)){
										$('.price').addClass('per_error').siblings().find('.per_err').show().siblings().hide().parent().siblings().removeClass('per_success')
										return false;
									}else{
										if(_this.prices>100000){
											$('.price').addClass('per_warning').siblings().find('.per_warn').show().siblings().hide().parent().siblings().removeClass('per_error per_success')
											return false;
										}else{
											$('.price').addClass('per_success').siblings().find('.per_suc').show().siblings().hide().parent().siblings().removeClass('per_error')
											if(_this.introduction>120){
												$('.introduction').addClass('per_error').siblings().find('.per_err').show().siblings().hide().parent().siblings().removeClass('per_success')
												return false;
											}else{
												$('.introduction').addClass('per_success').siblings().find('.per_suc').show().siblings().hide().parent().siblings().removeClass('per_error')
												_this.$axios.post('addpackage',{
													course_id:_this.courseId,
													package_name:_this.perTxt,
													total_table:_this.lessons,
													introduce:_this.introduction,
													price:(_this.prices*100),
													logo:_this.src
												}).then((res)=>{
													if(res.data.code == 200){
														var arr=[_this.dancelist.length-1,_this.courseId]
														sessionStorage.setItem('courseNum',JSON.stringify(arr))
														_this.$router.push({
											               	path:'/manager/addCategory/singleLesson'
											            })
														// _this.$axios.post('packagelist',{
										    //            		course_id:_this.courseId
										    //            	}).then(({data:{data}})=>{
										    //            		
										    //            	})
													}
													else{
														_this.$message.error(res.data.message)
													}
												}).catch( error =>{
													console.log(error)
												})
											}
										}
									}
								}
							}
						}
					}
				}
			},
			addUpload(){
				this.$refs.file.click()
			},
			qx_xj(){
				var _this=this;
				this.$confirm('此操作将取消新建期数, 是否继续?', '提示', {
		          	onfirmButtonText: '确定',
		          	cancelButtonText: '取消',
		         	type: 'warning'
		     	}).then(() => {
		          	_this.$message({
			            type: 'success',
			            message: '未新建期数!'
		         	});
		         	_this.$router.push({
	               		path:'/manager/addCategory/centersCon'
	               })	
		        }).catch(() => {
		          // this.$message({
		          //   type: 'info',
		          //   message: '已取消该操作'
		          // });          
		        });
			},
            add() {
                this.UPload = !this.UPload;
            },
            uploadButtonClose(){
            	this.UPload = !this.UPload;
            },
            selectImg(i){
				this.num=i;
				$('.vue-oss-imgsrc').eq(i).find('.mark').show().parent().siblings().find('.mark').hide()
			},
			qd_oss(){
				this.UPload = !this.UPload;
				this.src=$('.vue-oss-imgsrc').eq(this.num).find('img')[0].src;
			},
            //  时间戳
            timestamp:function(){  
                const time = new Date();  
                const y = time.getFullYear();  
                const m = time.getMonth()+1;  
                const d = time.getDate();  
                const h = time.getHours();  
                const mm = time.getMinutes();  
                const s = time.getSeconds();  
                const ms = time.getMilliseconds()  
                return ""+y+this.Add0(m)+this.Add0(d)+this.Add0(h)+this.Add0(mm)+this.Add0(s)+this.Add0(ms);  
            },
            Add0:function(m){  
                return m<10?'0'+m : m;  
            } ,
            uploadByOss (file) {
                let _this = this;
                //loadinginstace = Loading.service({ fullscreen: true })
               	return new Promise(function(resolve , reject){  // Promise 一定要在函数的最外层才有效
                    _this.$axios.post('oss/getOssParameter',{}).then(function (data) {
                        
                        var re = data.data.data
                        var osssignature = {
                            'key' : re.dir+file.name,
                            'policy': re.policy,
                            'OSSAccessKeyId': re.accessid,
                            'success_action_status' : '200', 
                            'signature': re.signature,
                            'callback':re.callback,
                        };
                        var formData = new FormData()
                        for( var k in osssignature ){
                            formData.append(k, osssignature[k])
                        }
                        formData.append("key", re.dir);
                        formData.append('file', file)  // 必须放最后
                        var xhr = new XMLHttpRequest()
                        xhr.open('POST', re.host, true)
                        xhr.send(formData)
                        xhr.onload = () => {
                            loadinginstace.close()
                            if (xhr.status === 200 || xhr.status === 304) {
                                if(_this.clnum == 1){
                                    _this.file_url1 = xhr.responseURL + re.dir + file.name
                                }
                                else if(_this.clnum == 4)
                                {
                                    _this.ksList[_this.clnums].zj_photo = xhr.responseURL + re.dir + file.name
                                }
                                //_this.cropShow=false
                                                      
                            } else {
                                console.log(`error：error code ${xhr.status}`)
                            }
                        }             
                    }).catch( error =>{
                        //loadinginstace.close()
                        console.log(error)
                    })
                })
            },
            fileChanged() {
            	const that=this;
            	const client = new OSS.Wrapper({
	                region: 'oss-cn-beijing',  
	                accessKeyId: 'LTAI3KlKGUP3vaoD',
	                accessKeySecret: 'S3wZCcPeMlAUl21rO1I8EKnlus8B0y',
	                bucket: 'yizi-kejian'
	            });
                const list = this.$refs.file.files
                for (let i = 0; i < list.length; i++) {
                    if (!this.isContain(list[i])) {
                        const item = {
                            name: list[i].name,
                            size: list[i].size,
                            file: list[i]
                        }
                        this.html5Reader(list[i], item)
                        this.files.push(item)
                    }
                }
                this.$refs.file.value = ''
                const fNum = this.files;
                // console.log(this.files)
                /*for(var i=0;i<fNum.length;i++){
*/              var f=fNum[fNum.length-1].file
                const Name=f.name
                const suffix = Name.substr(Name.indexOf("."));
                const obj=that.timestamp();
                const storeAs = 'kjzz/resources/course_'+that.courseId+'/rescourse/'+Name  //  路径+时间戳+后缀名
                client.multipartUpload(storeAs, f).then(function (result){
                	if(result.res.requestUrls[result.res.requestUrls.length-1].indexOf('?')>-1){
                		that.imgUrl.push(result.res.requestUrls[result.res.requestUrls.length-1].substring(0,result.res.requestUrls[result.res.requestUrls.length-1].lastIndexOf('?')))
                	}else{
                    		that.imgUrl.push(result.res.requestUrls[result.res.requestUrls.length-1])
                	}
                }).catch((err)=>{
                    console.log(err)
                })
               /* };*/
            },
            // 将图片文件转成BASE64格式
            html5Reader(file, item){
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.$set(item, 'src', e.target.result)
                }
                reader.readAsDataURL(file)
            },
            isContain(file) {
              return this.files.find((item) => item.name === file.name && item.size === file.size)
            },
		},
		created(){
			const that=this;
			that.$axios.post('getdancelist',{}).then( res =>{
				if(res.data.code == 200){
					that.dancelist=data;
				}
				else{
					that.$message.error(res.data.message)
				}
			}).catch( error =>{
				console.log(error)
			})
			const client = new OSS.Wrapper({
                region: 'oss-cn-beijing',  
                accessKeyId: 'LTAI3KlKGUP3vaoD',
                accessKeySecret: 'S3wZCcPeMlAUl21rO1I8EKnlus8B0y',
                bucket: 'yizi-kejian'
            });
			that.$axios.post('getcourseid',{
				name:localStorage.getItem('courseName')
			}).then(({data:{data}})=>{
				this.courseId=data.id
				console.log(data)
				 that.$nextTick(()=>{
	                client.list({
	                    'max-keys': 1000,
	                    'prefix'  : 'kjzz/resources/upload/course_'+that.courseId+'/rescourse/'
	                }).then(function (result) {
	                    for(var i=0;i<result.objects.length;i++){
	                		that.imgUrl.push(result.objects[i].url)
	                	}
	                }).catch(function (err) {
	                  console.log(err);
	                });
	            })
			})
		}
	};
</script>
<style scoped>
.nubPer_tit{
	background: #fff;
	width: 922px;
	height: 64px;
	box-sizing: border-box;
	padding-left: 30px;
	color: #333;
	font-weight: bold;
	line-height: 64px;
	font-size: 16px;
	margin-bottom: 10px;
}
.tishi{
	position: absolute;
	top:0;
	right: -130px;
	width: 130px;
	height: 40px;
	line-height: 40px;
	text-align: center;
}
.per_tet{
	position: relative;
}
.per_err{
	color: #DC143C;
	position: absolute;
	top: 0px;
	right: 0px;
	display: none;
}
.per_err1{
	margin-left: 10px;
	color: #DC143C;
	line-height: 40px;
	display: none;
}
.per_suc{
	color:#00FF7F ;
	position: absolute;
	top: 0px;
	right:-20px;
	text-align: left;
	width: 100%;
	height: 100%;
	display: none;
}

.per_warn{
	color:#DC143C;
	position: absolute;
	top: 0px;
	right:-10px;
	text-align: left;
	width: 100%;
	height: 100%;
	display: none;
}
.per_txt{
	width: 650px;
	height: 40px;
	line-height: 40px;
	font-size: 14px;
	padding-left: 24px;
	box-sizing: border-box;
	background: #f5f5f5;
	border:1px solid #ddd;
	border-radius: 4px;
}
.price,.lesson{
	width: 332px;
	height: 40px;
	line-height: 40px;
	font-size: 14px;
	padding-left: 24px;
	box-sizing: border-box;
	background: #f5f5f5;
	border:1px solid #ddd;
	border-radius: 4px;
}
.introduction{
	width: 648px;
	height: 80px;
	box-sizing: border-box;
	line-height: 16px;
	border:1px solid #ddd;
	background: #f5f5f5;
	resize: none;
	border-radius: 4px;
	padding: 13px 16px 13px 24px;
}
.per_warning{
	border:1px solid #DC143C;
}
.per_error{
	border:1px solid #DC143C;
}
.per_success{
	border:1px solid #00FF7F;
}
.arrow{
	display: inline-block;
	width: 27px;
	height: 27px;
	line-height: 20px;
	text-align: center;
	color: #8b92cf;
	border:3px solid #8b92cf;
	border-radius: 50%;
	box-sizing: border-box;
	margin-right: 12px;
}
	.fom_inf:after{
		content: "";
		display: block;
		clear: both;
	}
	.periods_form{
		background: #fff;
		padding-top: 30px;
		padding-bottom: 30px;
		width: 922px;
		box-sizing: border-box;
	}

	.periods_inf{
		margin-bottom: 30px;
	}
	.periods_inf:nth-last-of-type(1){
		margin-bottom: 0;
	}
	.tit{
		width: 106px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		padding-right: 20px;
		text-align: right;
	}
	
	.area_txt{
		position: relative;
	}
	.num_size{
		position: absolute;
		bottom: 13px;
		right: 16px;
		color: #999;
		font-size: 12px;
	}
	.btn_edit{
		margin-left: 106px;
		margin-top: 30px;
	}
	.btn{
		width: 102px;
		height: 36px;
		line-height: 36px;
		text-align: center;
		color: #fff;
		background: #595db5;
		border-radius: 4px;
		border:1px solid #595db5;
	}
	.btn1{
		border:1px solid #bfbfbf;
		color: #333;
		background: #fff;
		margin-left: 25px;
	}
	.upload label {
      width: 200px;
      height: 136px;
      display: block;
      border-radius: 2px;
      color: #fff;
      text-align: center;
      font-size: 12px;
      background-color: #f5f5f5;
      cursor: pointer;
      }
  input[type='file'] {
    display: none;
    z-index: 10;
    width: 200px;
    font-size: 0;
    height: 136px;
    opacity: 0;
  }
	.cFile{
		width: 200px;
		height: 136px;
		position: relative;
	}
	.add_img{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		text-align: center;
		font-size: 12px;
	}
	p{
		margin: 0;
		padding: 0;
	}
	.add_img p{
		color: #fff;
		background: #8b92cf;
		width: 28px;
		height: 28px;
		line-height: 28px;
		text-align: center;
		border-radius: 50%;
		transform: translateX(50%);
		margin-bottom: 9px;
	}
	.img-container{
		width: 200px;
		height: 136px;
		margin-right: 20px;
	}
	.img-container img{
		width: 100%;
		height: 100%;
	}
	input:focus{
		background: #fff;
	}


	/* .vue-uploader .file-list:after {
	    content: '';
	    display: block;
	    clear: both;
	    visibility: hidden;
	    line-height: 0;
	    height: 0;
	    font-size: 0;
	}
	.vue-uploader .file-list .file-item {
	    float: left;
	    margin-left: 10px;
	    position: relative;
	    width: 200px;
	    height: 136px;
	    line-height: 136px;
	    background: #ddd;
	    text-align: center;
	}
	.vue-uploader .file-list .draggable-item{
	width: 200px;
	    height: 136px;
	    line-height: 136px;
	    text-align: center;
	}
	.vue-uploader .file-list .file-item img{
	    max-width: 200px;
	    max-height: 136px;
	    display: inline-block;
	}
	.vue-uploader .file-list .file-item .file-remove {
	    position: absolute;
	    right: 4px;
	    display: none;
	    top: 4px;
	    width: 20px;
	    height: 20px;
	    font-size:20px;
	    text-align: center;
	    color: white;
	    cursor: pointer;
	    line-height: 20px;
	    border-radius: 100%;
	    transform: rotate(45deg);
	    background: rgba(0, 0, 0, 0.5);
	}
	.vue-uploader .file-list .file-item:hover .file-remove {
	    display: inline;
	}
	.vue-uploader .file-list .file-item .file-name {
	    margin: 0;
	    height: 40px;
	    word-break: break-all;
	    font-size: 14px;
	    overflow: hidden;
	    text-overflow: ellipsis;
	    display: -webkit-box;
	    -webkit-line-clamp: 2;
	    -webkit-box-orient: vertical;
	}
	.vue-uploader .add {
	    width: 200px;
	    height: 136px;
	    float: left;
	    cursor: pointer;
	    background: url(../../../static/imgs/upload.jpg) no-repeat;  // 这里使用的是我本地图片
	    background-size: 100% 100%;
	}
	.vue-uploader .upload-func {
	    display: flex;
	    padding: 10px;
	    margin: 0px;
	    background: #f8f8f8;
	    border-top: 1px solid #ececec;
	}
	.vue-uploader .upload-func .progress-bar {
	    flex-grow: 1;
	}
	.vue-uploader .upload-func .progress-bar section {
	    margin-top: 5px;
	    background: #00b4aa;
	    border-radius: 3px;
	    text-align: center; 
	    color: #fff;
	    font-size: 12px;
	    transition: all .5s ease;
	}
	.vue-uploader .upload-func .operation-box {
	    flex-grow: 0;
	    padding-left: 10px;
	}
	.vue-uploader .upload-func .operation-box button {
	    padding: 4px 12px;
	    color: #fff;
	    background: #007ACC;
	    border: none;
	    border-radius: 2px;
	    cursor: pointer;
	}
	.vue-uploader > input[type="file"] {
	    display: none;
	}
	
	
	
	.vue-oss-uploader-wrap{
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		width:100%;
		height: 100%;
		background: rgba(0,0,0,0.5);
	}
	.vue-oss-uploader{
		width: 846px;
		height: 538px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		background: #fff;
		border-radius: 10px;
	}
	.vue-oss-uploader-top{
		width:846px;
		height:50px;
		background:rgba(238,238,238,1);
		border-radius:10px 10px 0px 0px;
		position: relative;
	}
	.vue-oss-top-title{
		height:50px;
		font-size:14px;
		line-height: 50px;
		margin-left: 23px;
		font-weight:400;
		color:rgba(0,0,0,1);
		float: left;
	}
	.vue-oss-top-button{
		float: right;
		width:90px;
		height:30px;
		background:rgba(89,93,181,1);
		border-radius:4px;
		color: #fff;
		font-size: 14px;
		line-height: 30px;
		text-align: center;
		margin-top: 11px;
		margin-right: 67px;
		cursor: pointer;
	}
	.vue-oss-top-close{
		width: 22px;
		height: 22px;
		color: #999;
		position: absolute;
		top: 50%;
		margin-top: -11px;
		right: 20px;
		border-radius: 50%;
		border:1px solid #999;
		font-size: 20px;
		line-height: 18px;
		text-align: center;
		box-sizing: border-box;
	}
	.clearfixed:after{
		clear: both;
		content: "";
		display: block;
	}
	.vue-oss-uploader-content{
		width: 100%;
		height: 44px;
		box-sizing: border-box;
		padding: 19px 24px;
	}
	.vue-oss-uploader-information{
		overflow-y: auto;
		height: 438px;
	}
	.upload-button{
		width: 58px;
		padding-bottom: 5px;
		color: #999;
		text-align: center;
	}
	.vue-oss-imgsrc{
		margin: 10px 30px;
		width: 200px;
		height: 136px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
	}
	.vue-oss-imgsrc img{
		display: inline-block;
		vertical-align: middle;
		max-width:100%;max-height:100%;
		cursor:pointer;
	}
	.mark{
		display: none;
		position: absolute;
		top: 0;
		left: 0;
		background: rgba(0,0,0,.5);
		width: 200px;
		height: 136px;
		font-size: 50px;
		color: #fff;
		text-align: center;
		line-height: 136px;
		font-weight: 400;
	}
	.vue-oss-button{
		text-align: center;
		line-height: 20px;
	}
	.vue-oss-button span{
		width: 96px;
		height: 30px;
		background: #3f4399;
		display: inline-block;
		border-radius: 4px;
		color: #fff;
		line-height: 30px;
		text-align: center;
		cursor: pointer;
	} */
</style>


// WEBPACK FOOTER //
// src/components/index/newPeriods.vue